import { memoFn } from "@phosphor/utils";
import { getColorStyles } from "#scripts/lib/hooks/useColorStyles.ts";
import type { UID } from "#scripts/vmc/WorldState";

function hashString(str: string): number {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash;
  }
  return Math.abs(hash);
}

export const getUIDColor = memoFn((uid: UID | (string & {})) => {
  return getColorStyles({
    chroma: 0.3,
    hue: hashString(uid) % 360,
  });
});
